module.exports = __webpack_public_path__ + "static/media/menu.645834d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu.svg
// module id = 193
// module chunks = 0